export default (orderFromEstimation: number, estimationValue: number): number => {
    let reachedLiability: number = 0;
    if (estimationValue > 0) {
        reachedLiability = (orderFromEstimation / estimationValue) * 100;
    }
    return reachedLiability;
};



// WEBPACK FOOTER //
// ./src/domain/orders/getReachedLiabilityForSku.ts